import { Box, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { fNumber } from "src/utils/formatNumber";

export default function GameProviderUsersTable(props) {
	return props.rows === null ? (
		<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
			<CircularProgress />
		</Box>
	) : (
		<TableContainer component={Paper}>
			<Table sx={{ minWidth: 650 }} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell>User ID</TableCell>
						<TableCell>Username</TableCell>
						<TableCell>Amount</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{props.rows.length === 0 && (
						<Typography variant="body2" sx={{ padding: 2, textAlign: "center", width: "100%" }}>
							No users found
						</Typography>
					)}

					{props?.rows?.map((row, index) => (
						<TableRow
							key={index}
							sx={{
								"&:last-child td, &:last-child th": { border: 0 },
							}}
						>
							<TableCell component="th" scope="row">
								{row.userId}
							</TableCell>
							<TableCell component="th" scope="row">
								<a href={`/dashboard/profile?user_id=${row.userId}`}>{row.username}</a>
								{row.wins !== undefined && `(${row.wins} - ${row.losses})`}
							</TableCell>
							<TableCell component="th" scope="row">
								{fNumber(row.totalEntry)}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
